<template>
  <div
    class="article__date flex items-center leading-16 text-primary-200 text-sm space-x-3 mt-0 sm:mt-1"
    :class="[isOnedioVideo && !isMobile ? 'text-white' : 'text-[#7f8083]']"
  >
    {{ publishDate }}
    <span v-if="updateDate && !isUpdateSameWithPublish" class="ml-0.5 publish-date inline-block">
      {{ $t('news-page.last-update') }}: {{ updateDate }}
    </span>
  </div>
</template>

<script>
import { computed, defineComponent, inject } from '@nuxtjs/composition-api';
import { isVideoArticle } from '../utils/articleUtils';
import { articleDateFormat, isSameDate } from '~/modules/common/utils/dateUtils';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  props: {
    stn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const article = inject('article');
    const { isMobile } = useDevice();
    const publishDate = computed(() => articleDateFormat(article.dates?.published));
    const updateDate = computed(() => articleDateFormat(article.dates?.updated));
    const isOnedioVideo = computed(() => isVideoArticle(article) && !props.stn);
    const isUpdateSameWithPublish = computed(() => isSameDate(article.dates?.published, article.dates?.updated));
    return { article, articleDateFormat, publishDate, updateDate, isUpdateSameWithPublish, isMobile, isOnedioVideo };
  },
});
</script>

<style>
.publish-date::before {
  content: '\FF5C';
}
</style>
